import axios from '../index'


/**
 * 新闻资讯列表
 * typeId   所属端口
 limit    查询条数
 page     页数
 */
export function listContent(params) {
  return axios.post('/portal/content/listContent', params)
}

/**
 * 新闻资讯详情
 * typeId   所属馆id
 limit    查询条数
 page     页数
 */
export function getContentById(params) {
  return axios.post('/portal/content/getContentById', params)
}

/**
 * 上一条资讯信息
 * id 当前资讯id
 */
export function getUpContent(params) {
  return axios.post('/portal/content/getUpContent', params)
}

/**
 * 下一条资讯信息
 * id 当前资讯id
 */
export function getDownContent(params) {
  return axios.post('/portal/content/getDownContent', params)
}
